import Notification from './notification';

export default class Notifications {
   constructor(notifications = [], unreadCount = 0) {
      this._notifications = notifications;
      this._unreadCount = unreadCount;
   }

   getNotifications() {
      return this._notifications;
   }

   // Can exceed the number of unread notifications in the list, since the
   // backend sends at most 10
   getUnreadCount = () => this._unreadCount;

   // Shallow copy of actual list
   clone() {
      return new Notifications(Array.from(this._notifications), this._unreadCount);
   }

   // Only modifies notifications read property; does not update Redux
   setAllNotificationsAsRead() {
      this._notifications.forEach(notification => {
         notification.setRead();
      });

      this._unreadCount = 0;
   }

   setNotificationAsRead = signature => {
      const notification = this._notifications.find(
         notification => notification.signature === signature
      );
      notification && notification.setRead();

      this._unreadCount--;
   };

   addNewNotification = notificationData => {
      this._notifications.unshift(new Notification(notificationData));

      this._unreadCount++;
   };

   initializeNotifications = (notifications, unreadCount) => {
      this._notifications = notifications.map(
         notificationData => new Notification(notificationData)
      );

      this._unreadCount = unreadCount;
   };
}
